import React from "react";
import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import { useUser } from "../../api/useUser";
import { useSettings } from "../../api/useSettings";
import { useCanUserDoOnSomeProject } from "../canUserDo";

const useLocalSetupMode = createGlobalState({
  storage: "local",
  key: "setupMode",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});

export default function useSetupMode() {
  const user = useUser();
  const settings = useSettings();
  const hasSetupPermissionOnAnyProject = useCanUserDoOnSomeProject("PROJECT_SETUP");
  const canEnableSetupMode = settings.SETUP_MODE_FEATURE_ENABLED && hasSetupPermissionOnAnyProject;
  const [storedSetupModeEnabled, setStoredSetupModeEnabled] = useLocalSetupMode({ scope: user.id });

  const setSetupModeEnabled = React.useCallback(
    (isEnabled: boolean) => {
      if (!canEnableSetupMode) return;
      setStoredSetupModeEnabled(isEnabled);
    },
    [canEnableSetupMode, setStoredSetupModeEnabled],
  );

  return {
    canEnableSetupMode,
    isSetupModeEnabled: canEnableSetupMode && storedSetupModeEnabled,
    setSetupModeEnabled,
  };
}
